import { render, staticRenderFns } from "./CustomerRow.vue?vue&type=template&id=0e43cf61&scoped=true&"
import script from "./CustomerRow.vue?vue&type=script&lang=js&"
export * from "./CustomerRow.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRow.vue?vue&type=style&index=0&id=0e43cf61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e43cf61",
  null
  
)

export default component.exports